import { Modificar } from 'src/app/compartido/utilidades/compartido.models';
import {
  ClienteCrearDTO,
  ClienteDTO,
  DireccionDTO,
  DireccionEditarDTO,
  SedeDTO,
} from '../../clientes/utilidades/clientes.models';
import {
  DomicilioDTO,
  EstadoDomicilio,
} from 'src/app/domicilios/utilidades/domicilios.models';

/* Estados de Orden */
export enum EstadoOrden {
  CANCELADA = 'cancelada',
  POR_PREPARAR = 'por_preparar',
  PREPARADA = 'preparada',
  RECHAZADA = 'rechazada',
  RECOGIDA = 'recogida',
}

/* Serialización para creación del modelo Orden */
export interface OrdenCrearDTO {
  enumeracion: number | undefined;
  referencia: string | undefined;
  tipo: string | undefined;
  prioridad: string | undefined;
  origen: number | undefined;
  centro_costo: string | undefined;
  servicio: string | undefined;
  recaudo: number | undefined;
  direccion: DireccionEditarDTO;
  cliente: ClienteCrearDTO;
  items: ItemOrdenCrearDTO[];
  formulas: FormulaCrearDTO[];
  notas: string | undefined;
  antecesora?: number;
}

/* Serialización readonly del modelo Orden */
export interface OrdenDTO {
  id: number;
  fecha_creacion: string;
  autor_creacion: string | null;
  titulo: string;
  referencia: string | null;
  referencia_display: string | null;
  tipo: string;
  tipo_display: string;
  prioridad: string;
  prioridad_display: string;
  estado: EstadoOrden;
  estado_display: string;
  estado_real: EstadoOrden | EstadoDomicilio;
  estado_real_display: string;
  origen: SedeDTO | null;
  centro_costo: string | null;
  servicio: string | null;
  recaudo: number;
  direccion: DireccionDTO;
  cliente: ClienteDTO;
  items: ItemOrdenDTO[];
  formulas: FormulaDTO[];
  notas: string | null;
  antecesora: number | null;
  sucesora: number | null;
  domicilio: DomicilioDTO | null;
  etiqueta_generada: boolean;
  fecha_cancelacion: string | null;
  motivo_cancelacion: string | null;
  autor_cancelacion: string | null;
  observacion_cancelacion: string | null;
  fecha_aplazamiento: string | null;
  motivo_aplazamiento: string | null;
  observacion_aplazamiento: string | null;
  autor_aplazamiento: string | null;
  aplazada_hasta: string | null;
  tipo_preparacion: TipoPreparacion | null;
  tipo_preparacion_display: string | null;
  fecha_preparacion: string | null;
  motivo_rechazo: string | null;
  autor_preparacion: string | null;
  observacion_preparacion: string | null;
  sin_domicilio: boolean;
  motivo_sin_domicilio: string | null;
  fecha_recogida: string | null;
  autor_recogida: string | null;
  planilla: number | null;
}

/* Tipos de preparación de orden */
export enum TipoPreparacion {
  PARCIAL = 'parcial',
  TOTAL = 'total',
}

/* Serialización para creación del modelo Fórmula */
export interface FormulaCrearDTO {
  referencia: string | undefined;
  archivo: File | undefined;
}

/* Serialización readonly del modelo Fórmula */
export interface FormulaDTO
  extends Modificar<FormulaCrearDTO, { archivo: string | null }> {
  id: number;
}

/* Serialización para creación del modelo ItemOrden */
export interface ItemOrdenCrearDTO {
  orden?: number;
  cantidad: number;
  producto: ProductoCrearDTO;
}

/* Serialización readonly del modelo ItemOrden */
export interface ItemOrdenDTO
  extends Modificar<ItemOrdenCrearDTO, { producto: ProductoDTO }> {
  id: number;
  orden: number;
}

/* Serialización para creación del modelo Producto */
export interface ProductoCrearDTO {
  nombre: string;
  id_externo: string | undefined;
}

/* Serialización readonly del modelo Producto */
export interface ProductoDTO {
  nombre: string;
  id_externo: string | null;
  id: number;
}
